"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateRoot = void 0;
const Entity_1 = require("./Entity");
class AggregateRoot extends Entity_1.Entity {
    getLogType() {
        return 'aggregate';
    }
}
exports.AggregateRoot = AggregateRoot;
